import { render } from "./FooterPanel.vue?vue&type=template&id=7aefdef8&scoped=true"
import script from "./FooterPanel.vue?vue&type=script&lang=js"
export * from "./FooterPanel.vue?vue&type=script&lang=js"

import "./FooterPanel.vue?vue&type=style&index=0&id=7aefdef8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aefdef8"]])

export default __exports__